// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "AnchorLinks-module--cds--assistive-text--f0246";
export var cdsHideFeedback = "AnchorLinks-module--cds--hide-feedback--0b388";
export var cdsShowFeedback = "AnchorLinks-module--cds--show-feedback--f7448";
export var cdsSkeleton = "AnchorLinks-module--cds--skeleton--af6a1";
export var cdsVisuallyHidden = "AnchorLinks-module--cds--visually-hidden--f66b3";
export var link = "AnchorLinks-module--link--f557e";
export var list = "AnchorLinks-module--list--14e3f";
export var listSmall = "AnchorLinks-module--list--small--d543a";
export var multipleColumns = "AnchorLinks-module--multiple-columns--58190";